import { render, staticRenderFns } from "./ucBanner.vue?vue&type=template&id=0b2f8fd0"
import script from "./ucBanner.vue?vue&type=script&lang=js"
export * from "./ucBanner.vue?vue&type=script&lang=js"
import style0 from "./ucBanner.vue?vue&type=style&index=0&id=0b2f8fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports